import React, { useState } from 'react';
import { Modal, Form, Input, Button, Tabs, InputNumber, Radio } from 'antd';
import IntlMessage from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import addonsApi from '../../api/addons';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const { TextArea } = Input;

const AddonsForm = ({ onClose, currentData, open, onReload }) => {
  // states
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  let initialValues = {
    title: currentData && currentData.title ? currentData.title : '',
    email: currentData && currentData.email ? currentData.email : '',
    description:
      currentData && currentData.description ? currentData.description : '',
    price: currentData && currentData.price ? currentData.price : 0,
    type: currentData && currentData.type ? currentData.type : 'seat',
  };
  const intl = useIntl();

  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        let payload = { ...values };
        // console.log('values submitted', payload);

        if (currentData) {
          addonsApi
            .update(currentData?.id, payload)
            .then(() => {
              setLoading(false);
              handleCancel();
              onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        } else {
          addonsApi
            .create(payload)
            .then(() => {
              setLoading(false);
              handleCancel();
              onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const tabItems = [
    {
      key: '1',
      label: <IntlMessage id="global.addons" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input
              placeholder={intl.formatMessage({
                id: 'placeholder.input_title',
              })}
            />
          </Form.Item>

          {/* <Form.Item
            label={<IntlMessage id="global.email" />}
            name="email"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
              {
                type: 'email',
                message: <IntlMessage id="validate.is_not_email" />,
              },
            ]}
          >
            <Input
              placeholder={intl.formatMessage({
                id: 'placeholder.input_email',
              })}
            />
          </Form.Item> */}

          <Form.Item
            label={<IntlMessage id="global.price" />}
            name="price"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <InputNumber
              min={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
            />
          </Form.Item>

          <Form.Item label={<IntlMessage id="global.type" />} name="type">
            <Radio.Group>
              <Radio value={'seat'}>
                <IntlMessage id="global.seat" />
              </Radio>
              <Radio value={'item'}>
                <IntlMessage id="global.item" />
              </Radio>
            </Radio.Group>
          </Form.Item>
        </>
      ),
    },
    {
      key: '2',
      label: <IntlMessage id="global.description" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.description" />}
            name="description"
            rules={[
              {
                required: false,
              },
            ]}>
            <TextArea rows={4} />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessage id="global.edit" />
        ) : (
          <IntlMessage id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessage id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValues}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems} />
      </Form>
    </Modal>
  );
};

export default AddonsForm;
